export default __webpack_public_path__ + "static/media/card1.4064656a.png";